(function () {
    'use strict';
    $(document).ready(function () {

        function setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            let expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        function getCookie(cname) {
            let name = cname + "=";
            let ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        function fhpCookiesConvertTypes(cookiesTypes) {

            $("script").each(function () {
                if ($(this).data('fhpc')) {
                    var dataFHC = $(this).data('fhpc').split(' ');

                    if ((dataFHC.every(r => cookiesTypes.includes(r)))) {
                        var newScript = $("<script type='text/javascript'>")

                        newScript.text($(this).text());
                        newScript.attr('data-fhpc', $(this).attr('data-fhpc'))
                        if($(this).attr('async')){
                            newScript.attr('async', 'async');
                        }
                        if($(this).attr('data-src')){
                            newScript.attr('src', $(this).attr('data-src'));
                        }

                        $(this).after(newScript);
                        $(this).remove();
                    }
                }
            });

            $("iframe").each(function () {
                if ($(this).data('fhpc')) {
                    var dataFHC = $(this).data('fhpc').split(' ');

                    if ((dataFHC.every(r => cookiesTypes.includes(r)))) {
                        $(this).attr('src', $(this).data('src'));
                    }
                }
            });
        }

        function fhpCookiesClosePopup() {
            $('.fhp-cookies .fhp-cookies-popup').fadeOut();
            $('.fhp-cookies').fadeOut();
            $('body').removeClass('fhp-no-scroll');
        }

        function fhpCheckCheckedConsents(cookiesTypes) {
            $('.fhp-cookies #fhp-cookies-consent-functional').prop('checked', false);
            $('.fhp-cookies #fhp-cookies-consent-analytical').prop('checked', false);
            $('.fhp-cookies #fhp-cookies-consent-marketing').prop('checked', false);
            
            cookiesTypes.forEach(function(cookieType) {
                $('.fhp-cookies #fhp-cookies-consent-' + cookieType).prop('checked', true);
            });
        }

        if (!getCookie('fhpcookie')) {
            $('.fhp-cookies').show();
        } else {
            var fhpcookie = getCookie('fhpcookie').split(',');
            fhpCookiesConvertTypes(fhpcookie);
            fhpCheckCheckedConsents(fhpcookie);
        }

        $('.fhp-cookies #fhp-cookies-accept-all').on('click', function () {
            var fhcChoices = 'required,functional,analytical,marketing';
            setCookie('fhpcookie', 'required,functional,analytical,marketing', 30);

            var fhcChoicesArray = fhcChoices.split(',');

            fhpCookiesConvertTypes(fhcChoicesArray);
            fhpCheckCheckedConsents(fhcChoicesArray);
            fhpCookiesClosePopup();
        });

        $('.fhp-cookies #fhp-cookies-reject-all').on('click', function () {
            var fhcChoices = 'required';
            setCookie('fhpcookie', fhcChoices, 30);

            var fhcChoicesArray = ['required'];

            fhpCheckCheckedConsents(fhcChoicesArray);
            fhpCookiesClosePopup();
        });

        $('.fhp-cookies #fhp-cookies-save-choice').on('click', function () {
            var fhcChoices = 'required';
            if ($('#fhp-cookies-consent-functional:checked').val()) {
                fhcChoices += ',functional';
            }
            if ($('#fhp-cookies-consent-analytical:checked').val()) {
                fhcChoices += ',analytical';
            }
            if ($('#fhp-cookies-consent-marketing:checked').val()) {
                fhcChoices += ',marketing';
            }

            setCookie('fhpcookie', fhcChoices, 30);

            var fhcChoicesArray = fhcChoices.split(',');

            fhpCookiesConvertTypes(fhcChoicesArray);
            fhpCheckCheckedConsents(fhcChoicesArray);
            fhpCookiesClosePopup();
        });

        $('.fhp-cookies #fhp-cookies-settings, .fhp-cookies-open-settings, a[href="#fhp-cookies-open-settings"]').on('click', function(e) {
            e.preventDefault();
            $("html, body").animate({
                scrollTop: 0
            }, 0);
            $('body').addClass('fhp-no-scroll');
            $('.fhp-cookies, .fhp-cookies .fhp-cookies-popup').fadeIn();
        });

        $('.fhp-cookies .fhp-cookies-settings-content').mCustomScrollbar({
            axis: "y",
            mouseWheel: {
                enable: true
            }
        });

        const button = document.querySelector('button.expand');
        button?.addEventListener('click', () => {
            document.querySelector('.fhp-cookies-info').classList.toggle('open');
            button.textContent = button.textContent === fhTranslate('expand') ? fhTranslate('collapse') : fhTranslate('expand');
            $('.fhp-cookies-info .hidden').fadeToggle();
        })

    });
}(jQuery));
